import './App.css';
import React, {useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import jwt from 'jwt-decode'
import { useEventSource } from '@components/App/useEventSource';
import NavBar from '@shared/NavBar/NavBar';
import Dashboard from '@components/Dashboard/Dashboard';
import OperatorLobby from '@components/operatorLobby/OperatorLobby';
import ReactModal from 'react-modal';

function App() {

  ReactModal.setAppElement('body');

  const { isLoading, isAuthenticated, error, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState(null);

  let innerContent = null;

  let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {(async() => {
    if(isAuthenticated) {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE
        });
        setToken(token);
      } catch(error) {
        console.error(error);
      }
    }
  })()}, [getAccessTokenSilently, isAuthenticated]);

  const { listOfUsers, listOfAvailableVehicles, isBackendConnected } = useEventSource(token, isAuthenticated);

  if (error) {
    innerContent = <h3>Oops... {error.message}</h3>;
  } else if (isAuthenticated) {
    if(isLoading || token == null) {
      innerContent = <h3>Authentication in progress...</h3>;
    } else if (isBackendConnected) {
      if(listOfUsers.length > 0) {
        const permissions = jwt(token).permissions;
        const isAdministrator = permissions.includes('read:dashboard');
        innerContent = isAdministrator ? <Dashboard listOfUsers={listOfUsers} /> : <OperatorLobby token={token} isMobile={isMobile} listOfAvailableVehicles={listOfAvailableVehicles} operator={listOfUsers[0]} />;
        // innerContent = isAdministrator ? <Dashboard listOfUsers={listOfUsers} /> : <VehicleDashboard token={token} isMobile={isMobile} listOfAvailableVehicles={listOfAvailableVehicles} operator={listOfUsers[0]} />;
      } else {
        innerContent = <h3>Retreiving user infos...</h3>;
      }
    } else {
      innerContent = <h3>Connecting to backend...</h3>;
    }
  } else {
    if(isLoading) {
      innerContent = <h3>Loading...</h3>
    } else {
      innerContent = <h3>Please use the login button.</h3>
    }
  }

  useEffect(() => {
    function handleScroll() {
      document.getElementById("body").dataset.scrollfixed = window.scrollY >= 56 ? "on" : "off";
    }

    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const content =
    <div id="body" className="d-flex flex-column h-100 min-vh-100">
      <NavBar />
      <div id="main" className="flex-fill-0">
      {/* <div id="main" className="flex-shrink-0"> */}
        <div className="container-fluid">
          {innerContent}
        </div>
      </div>
      { !isMobile &&
      <div id="footer" className="footer mt-auto py-3 bg-light">
        <div className="container">
          <span className="text-muted">Copyright © ROSAS {new Date().getFullYear()}</span>
        </div>
      </div>
      }
    </div>

  return content;
}

export default App;
